import * as types from "../constants/ActionTypes";
import {clearToolTip} from "./";

function isSubset(item, seed) {
    return Object.keys(seed).every(key => {
        return seed[key] === item[key];
    });
}

function findSubset(items, seed) {
    let index = 0;
    for (let item of items) {
        if (isSubset(item, seed)) {
            return index;
        }
        index++;
    }

    return -1;
}

export function selectChart(index) {
    return (dispatch, getState) => {
        if (typeof index === "object") {
            let {charts} = getState();
            let seed = index;
            index = findSubset(charts, seed);

            if (index === -1) {
                throw new Error("Could not select chart", seed);
            }
        }

        dispatch({
            type: types.SELECT_CHART,
            index
        });
    };
}

export function expose(on) {
    return (dispatch, getState) => {
        dispatch({
            type: types.TOGGLE_EXPOSE,
            on
        });

        if (on) {
            dispatch(clearToolTip());
        }
    };
}

export function loadState(args = {}) {
    return {
        type: types.LOAD_STATE,
        args
    };
}



// WEBPACK FOOTER //
// ./src/kpi/store/actions/ViewActions.js